import { useSelector } from 'react-redux';
import { Questionnaire } from '../../../../types';
import { selectBlockingAnswers } from '../../../../../../redux/questionnaire/selectors';
import { useEffect, useRef } from 'react';
import { UseFormSetValue } from 'react-hook-form';

export const useSyncBlockingAnswers = (setValue: UseFormSetValue<Questionnaire>) => {
  const blockingAnswers = useSelector(selectBlockingAnswers);
  const isInitialLoad = useRef(true);

  useEffect(() => {
    if (isInitialLoad.current) {
      setValue('blocking_answers', blockingAnswers);
      isInitialLoad.current = false;
    } else {
      setValue('blocking_answers', blockingAnswers, { shouldDirty: true });
    }
  }, [blockingAnswers, setValue]);
};
